import { Component, OnInit } from '@angular/core';
import {DataService} from '../data.service';
import {CountryService} from '../country.service';
import {ActivatedRoute, Router} from '@angular/router';
// import { } from '@types/googlemaps';
import {split} from 'ts-node';

declare var $: any;
declare var Nanobar: any;
declare var google: any;
declare var toastr: any;

@Component({
  selector: 'app-edit-customer-address',
  templateUrl: './edit-customer-address.component.html',
  styleUrls: ['./edit-customer-address.component.css']
})
export class EditCustomerAddressComponent implements OnInit {

  id: any;
  private sub: any;
  nao = new Nanobar();
  countryCode: any;
  countryCode2: any;
  maxYear: any;
  first_name: any;
  last_name: any;
  number: any;
  number2 = '';
  email: any;
  setLabel = 'Home';
  is_tax_exempt = false;
  accept_marketing = false;
  address_line1: any;
  address_line2: any;
  city: any;
  state: any;
  zip: any;
  dob: any;
  emailChk: any;
  area: any;
  apart: any;
  note: any;
  findCustomerData: any;
  customerMatch = false;
  street: any;
  latitude: any;
  longitude: any;
  userImage: any;
  numChk = false;
  place: any;
  validateNumberSucces: any;
  validateChk = true;
  phoneNumToSend: any;
  btnDisable: any;
  restErrorCode: any;
  success: any;
  addingCustomer: any;
  error_count: any;
  errorMsg: any;
  clearTimeout: any;
  placeSuggestionsData: any;
  placeDetailData: any;
  placeDataFound = false;
  addressLoad = false;
  dobToDisplay: any;
  private today = new Date();
  selDate: any;
  selectAddress = false;
  customLabel: any;
  labelCount = -1;
  addCustomerAddress: any;
  country: any;
  addCustomerId: any;
  adressIndex = 1;
  customerName = '';
  setLabelDefault = '';
  selectCustom = '';
  editHouseNo: string;
  constructor(private route: ActivatedRoute, private dataService: DataService, private router: Router,  private cs: CountryService) {
    this.sub = this.route.params.subscribe(params => {
      this.id = params['id']; // (+) converts string 'id' to a number
      this.id = this.id.split('&', 2);
      console.log(this.id);
      this.adressIndex = this.id[1];
      this.id = this.id[0];
      this.adressIndex = Number(this.adressIndex);
      this.id = Number(this.id);
      console.log('this.id', this.id);
    });
  }
  functionTogetPlace () {
    if ( this.selectAddress === true ){
      return;
    }
    this.placeDataFound = false;
    this.placeSuggestionsData = [];
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      // this.addressLoad = true;
      this.dataService.googleAddress(this.address_line1).subscribe(
        (data) => {
          this.placeSuggestionsData = data;
          this.placeSuggestionsData = this.placeSuggestionsData.predictions;
          console.log('place google data', this.placeSuggestionsData);
          this.placeDataFound = true;
          if ($('.myDrop').hasClass('open')) {

          } else {
            $('.myDrop').addClass('open');
          }
          // this.addressLoad = false;
          // $('#searchTextField').click();
          // $('#searchTextField').focus();
        },
        (error) => {
        }
      );
    }, 1000);
  }
  functionTogetPlaceDetail (name, id) {
    this.addressLoad = true;
    this.address_line1 = name;
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      this.dataService.googleAddressDetail(id).subscribe(
        (data) => {
          console.log('place google detail data', data);
          this.placeDetailData = data;
          this.selectAddress = true;
          this.placeDetailData = this.placeDetailData.result;
          this.latitude = this.placeDetailData.geometry.location.lat;
          this.longitude = this.placeDetailData.geometry.location.lng;
          console.log('this.latitude', this.latitude);
          console.log('this.longitude', this.longitude);
          this.placeDetailData = this.placeDetailData.address_components;
          this.callMap();
          setTimeout(() => {
            this.addressDetail();
            this.addressLoad = false;
          }, 1000);
        },
        (error) => {
        }
      );
    }, 1000);
  }
  callMap(){
    setTimeout(() => {
      var context = this;
      var map;
      var marker;
      var adr;
      var myLatlng = new google.maps.LatLng( this.latitude , this.longitude);
      var geocoder = new google.maps.Geocoder();
      var infowindow = new google.maps.InfoWindow();
      var mapOptions = {
        zoom: 14,
        center: myLatlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        navigationControl: false,
        // mapTypeControl: false,
        // disableDefaultUI: true
      };
      var endImage = {
        url: 'assets/pin.png', // url
        scaledSize: new google.maps.Size(30, 42), // scaled size
        origin: new google.maps.Point(0, 0), // origin
        anchor: new google.maps.Point(16, 41) // anchor
      };
      map = new google.maps.Map(document.getElementById('myMap'), mapOptions);
      marker = new google.maps.Marker({
        map: map,
        position: myLatlng,
        draggable: true,
        icon: endImage,
      });
      geocoder.geocode({'latLng': myLatlng }, function(results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            // $('#address').val(results[0].formatted_address);
            // $('#latitude').val(marker.getPosition().lat());
            // $('#longitude').val(marker.getPosition().lng());
            infowindow.setContent(results[0].formatted_address);
            infowindow.open(map, marker);
            context.latitude = marker.getPosition().lat();
            context.longitude = marker.getPosition().lng();
            console.log( context.latitude, context.longitude);
            console.log('results', results);
            // context.getDeliveryAddressDetail(results[0]);

          }
        }
      });


      google.maps.event.addListener(marker, 'dragend', function() {
        geocoder.geocode({'latLng': marker.getPosition()}, function(results, status) {
          if (status === google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              infowindow.setContent(results[0].formatted_address);
              infowindow.open(map, marker);
              context.latitude = marker.getPosition().lat();
              context.longitude = marker.getPosition().lng();
              // context.addressNew =  results[0].formatted_address;
              console.log( context.latitude, context.longitude);
              console.log('results', results);
              // this.changeRef.detectChanges();
              // context.getDeliveryAddressDetail(results[0]);
            }
          }
        });
      });
    }, 500);
  }
  resetAddress(){
    this.address_line1 = '';
    // this.address_line2 = '';
    this.city = '';
    this.state = '';
    this.zip = '';
    this.area = '';
    this.apart = '';
    this.editHouseNo = '';
    this.longitude = '';
    this.latitude = '';
    this.selectAddress = false;
  }
  addressDetail() {
    this.street = '';
    console.log('chk address detail', this.place);
    for(var i = 0; i < this.placeDetailData.length; i++) {
      for(var j = 0; j < this.placeDetailData[i].types.length; j++) {
        if (this.placeDetailData[i].types[j] === 'administrative_area_level_2') {
           $('#city').val(this.placeDetailData[i].long_name);
        }
        else if (this.placeDetailData[i].types[j] === 'locality') {
          // this.city = this.place.address_components[i].long_name;
          // console.log('city', this.city);
          $('#city').val(this.placeDetailData[i].long_name);
        }
        if (this.placeDetailData[i].types[j] === 'street_number') {
          this.street = this.placeDetailData[i].long_name;
          console.log('street number', this.street);
        }
        if (this.placeDetailData[i].types[j] === 'route') {
          this.street = this.street + ' ' + this.placeDetailData[i].long_name;
          console.log('route', this.street);
        }
        if (this.placeDetailData[i].types[j] === 'sublocality_level_2') {
          this.street = this.street + ' ' + this.placeDetailData[i].long_name;
          console.log('sublocality 2', this.street);
        }
        if (this.placeDetailData[i].types[j] === 'sublocality_level_1') {
          this.street = this.street + ' ' + this.placeDetailData[i].long_name;
          console.log('sublocality 1', this.street);
        }
        //   this.street = this.place.name;
        //   console.log('this.street', this.street);

        if (this.placeDetailData[i].types[j] === 'administrative_area_level_1') {
          $('#state').val(this.placeDetailData[i].short_name);
        }

        if (this.placeDetailData[i].types[j] === 'country') {
          // this.area = this.place.address_components[i].long_name;
          $('#area').val(this.placeDetailData[i].long_name);
        }

        if (this.placeDetailData[i].types[j] === 'postal_code') {
          // this.zip = this.place.address_components[i].long_name;
          console.log('postal; code', this.placeDetailData[i].long_name);
          $('#zip').val(this.placeDetailData[i].long_name);
        } else {
          $('#zip').val('');
        }
      }
    }
  }




  findCustomer() {
    // this.nao.go(30);
    this.dataService.showCustomerListById(window.localStorage.getItem('token'), this.id).subscribe(
      (data) => {
        // this.nao.go(100);
        this.findCustomerData = data;
        this.customerName = this.findCustomerData.first_name + ' ' + this.findCustomerData.last_name;
        // this.findCustomerData = this.findCustomerData.address_list.address_dictionary;
        this.selectAddress = true;
        // this.setLabel = 'Work';
        for ( var i = 0; i < this.findCustomerData.address_list.address_dictionary.length; i++ ) {
          if (this.adressIndex === this.findCustomerData.address_list.address_dictionary[i].id) {
            this.setLabel = this.findCustomerData.address_list.address_dictionary[i].place_label;
            this.address_line1 = this.findCustomerData.address_list.address_dictionary[i].address_line1;
            this.apart = this.findCustomerData.address_list.address_dictionary[i].apart_no;
            this.editHouseNo = this.findCustomerData.address_list.address_dictionary[i].house_building_no;
            this.city = this.findCustomerData.address_list.address_dictionary[i].city;
            this.area = this.findCustomerData.address_list.address_dictionary[i].country;
            this.zip = this.findCustomerData.address_list.address_dictionary[i].zip;
            this.state = this.findCustomerData.address_list.address_dictionary[i].state;
            this.longitude = this.findCustomerData.address_list.address_dictionary[i].longitude;
            this.latitude = this.findCustomerData.address_list.address_dictionary[i].latitude;
            this.callMap();
          }
        }
      },
      (error) => {
        // this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  editClose() {
    this.customerMatch = true;
  }

  // AddInventorylistPopup(variant) {
  //     this.addInventryObj = variant;
  //    console.log('variant', variant);
  //    this.addInventryCost = variant.variant_cost;
  //     $('#addConformPopup').modal('show');
  //      $('#addOutletId').val(this.outletID);
  //     this.addInventryItem = null;
  //   }

  setLabelPopup() {
    this.setLabelDefault = this.setLabel;
    // this.customLabel = null;
    $('#addConformPopup').modal('show');
  }
  setCheckLabel(value) {
    this.setLabelDefault = value;
    if (value === 'Work' || value === 'Home') {
      this.customLabel = '';
    }
  }
  checkLabel(value1) {
    this.selectCustom = '';
    this.setLabelDefault = '';
    if ( value1 === 'Home' ) {
      this.selectCustom = 'Please Select Home from above';
    }
    if ( value1 === 'Work' ) {
      this.selectCustom = 'Please Select Work from above';
    }
    if ( value1 === '' ) {
      this.setLabelDefault = 'Home';
    }
    // if (value1 === 'Work' || value1 === 'Home'){
    //   this.customLabel = '';
    // }
  }
  capitlizeFirstName() {
    this.customLabel = this.customLabel.replace(/\b\w/g, function(l) { return l.toUpperCase()});
  }
  doneSetLabelPopup() {
    if ( this.customLabel === 'Home' || this.customLabel === 'Work' ) {
      return;
    }
    if ( this.setLabelDefault !== '') {
      this.setLabel = this.setLabelDefault;
    } else {
      this.setLabel = this.customLabel;
    }
    $('#addConformPopup').modal('hide');
  }

  // getCustomerAddAddress(){
  //   this.nao.go(30);
  //   this.dataService.addCustomerAddress(window.localStorage.getItem('token'), this.address_line1, this.apart, this.city,this.country, this.latitude, this.longitude, this.setLabel, this.state, this.zip ).subscribe(
  //     (data) => {
  //       this.nao.go(100);
  //       this.customerAddress = data;
  //
  //     },
  //     (error) => {
  //       this.nao.go(100);
  //       console.log('error', error);
  //     }
  //   );
  // }

  updateAddCustomerAddress() {
    this.error_count = 0;
    $('.c-label label').css('color', '#3d3e3d');
    $('.uploadText').css('color', '#3d3e3d');
    $('.c-label input').css('border-color', '#ccc');
    $('.c-label textarea').css('border-color', '#ccc');
    this.addingCustomer = true;
    if ($('#is_tax_exempt').is(':checked')) {
      this.is_tax_exempt = true;
    }
    if ($('#accept_marketing').is(':checked')) {
      this.accept_marketing = true;
    }
    this.city = $('#city').val();
    this.zip = $('#zip').val();
    this.state = $('#state').val();
    this.area = $('#area').val();
    this.apart = $('#apart').val();
    this.editHouseNo = $('#editHouseNo').val();
    // this.dob = $('#datepicker').val();
    // console.log('dob before', this.dob);
    // this.dob = this.dob.formatted;
    // console.log('dob after', this.dob);
    // this.number2 = $('#phoneValue').val();
    this.address_line1 = $('#c-address input').val();
    console.log('login data');


    if (this.address_line1 === '' || this.address_line1 === undefined) {
      $('#c-address label').css('color', '#a10a0d');
      $('#c-address input').css('border-color', '#a10a0d');
      this.error_count ++;
    }
    if (this.city === '' || this.city === undefined) {
      $('#c-city label').css('color', '#a10a0d');
      $('#c-city input').css('border-color', '#a10a0d');
      this.error_count ++;
    }
    if (this.zip === '' || this.zip === undefined) {
      $('#c-zip label').css('color', '#a10a0d');
      $('#c-zip input').css('border-color', '#a10a0d');
      this.error_count ++;
    }
    // if (this.state === '' || this.state === undefined) {
    //   $('#c-state label').css('color', '#a10a0d');
    //   $('#c-state input').css('border-color', '#a10a0d');
    //   this.error_count ++;
    // }
    // if (this.area === '' || this.area === undefined) {
    //   $('#c-area label').css('color', '#a10a0d');
    //   $('#c-area input').css('border-color', '#a10a0d');
    //   this.error_count ++;
    //   console.log('add address-area');
    // }
    // if (this.error_count > 0) {
    //   return;
    // }


    // if (this.number2 !== '' && this.number2 !== undefined) {
    //   // || this.numChk === true
    //   console.log('number', this.number2);
    //   var getCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
    //   this.phoneNumToSend = '+' + getCode + '' + this.number2;
    //   console.log('number', this.phoneNumToSend);
    // }
    // var getCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
    // this.number = '+' + getCode + this.number;
    // console.log('number', this.number);
    this.nao.go(30);
    this.btnDisable = true;
    this.street = this.address_line1;
    console.log('add address-area');

    this.dataService.editCustomerAddress(window.localStorage.getItem('token'),
      this.setLabel, this.address_line1, this.city,
      this.state, this.zip, this.area, this.apart, this.id, this.latitude, this.longitude, this.adressIndex, this.editHouseNo).subscribe(
      (data) => {

        this.validateChk = true;
        console.log('outlet data');
        this.nao.go(100);
        this.restErrorCode = data;
        this.restErrorCode = this.restErrorCode.rest_error_code;
        this.success = data;
        this.errorMsg = data;
        this.errorMsg = this.errorMsg.message;
        this.success = this.success.success;
        if (this.restErrorCode === 1) {
          toastr.error('Some thing went wrong');
          this.btnDisable = false;
        }
        if (this.restErrorCode === 2) {
          toastr.error('Please login again');
          this.btnDisable = false;
        }
        if (this.restErrorCode === 3) {
          toastr.error('Customer already exists');
          this.btnDisable = false;
        }
        if (this.restErrorCode === 4) {
          toastr.error('Customer does not exist');
          this.btnDisable = false;
        }
        if (this.success === true) {
          this.btnDisable = false;
          toastr.success('Successfully updated');
          // this.router.navigate(['customers']);
          this.editClose();
          this.router.navigate(['customers', this.id]);
        }
        if (this.success === false) {
          this.addingCustomer = false;
          this.btnDisable = false;
          toastr.error(this.errorMsg);
        }
      },
      (error) => {
        this.nao.go(100);
        this.addingCustomer = false;
        this.btnDisable = false;
        console.log('error', error);
      }
    );
  }


  ngOnInit() {
    this.findCustomer();
  }

}



// WEBPACK FOOTER //
// ./src/app/edit-customer-address/edit-customer-address.component.ts